import axios from 'axios';
import { isTokenExpired } from './security';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  headers: { 'Content-Type': 'application/json' },
  timeout: 15000, // 15 second timeout — prevent hanging requests
});

// ─── REQUEST interceptor ─────────────────────────────────────────────────────
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');

  if (token) {
    // Auto-logout if token is expired before even sending the request
    if (isTokenExpired(token)) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
      return Promise.reject(new Error('Session expired'));
    }
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
}, (error) => Promise.reject(error));

// ─── RESPONSE interceptor ────────────────────────────────────────────────────
API.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status;

    if (status === 401) {
      // Token rejected by server — clear session and redirect
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }

    if (status === 403) {
      // Forbidden — user doesn't have permission, redirect to dashboard
      window.location.href = '/dashboard';
    }

    if (status === 429) {
      // Rate limited by backend — show descriptive error
      err.message = err.response?.data?.message || 'Too many requests. Please slow down.';
    }

    return Promise.reject(err);
  }
);

export default API;
